import { render, staticRenderFns } from "./listVue.vue?vue&type=template&id=42206bc8&scoped=true&"
import script from "./listVue.vue?vue&type=script&lang=js&"
export * from "./listVue.vue?vue&type=script&lang=js&"
import style0 from "./listVue.vue?vue&type=style&index=0&id=42206bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42206bc8",
  null
  
)

export default component.exports